import ProductArrivalMessage from './ProductArrivalMessage'

export default ProductArrivalMessage
